//import User from '~/models/User'

export default [
    ...applyRules(['guest'], [
        {
            path: '/login', component: require('@/components/layouts/AuthLayout').default, redirect: { name: 'login' }, props: (route) => ({
                            email: route.query.email,
                            reset_token: route.query.reset_token,
                    }), children:
                [
                    { path: '/login', name: 'login', component: require('@/views/auth/Login').default },
                    { path: '/register', name: 'register', component: require('@/views/auth/Register').default },
                    { path: '/passwordreset', name: 'passwordreset', component: require('@/views/auth/PasswordReset').default },
                    // {
                        // path: '/password', children:
                            // [
                                { path: '/password', name: 'forgot', component: require('@/views/auth/PasswordForgot').default },
                                // { path: 'reset/:token', name: 'reset', component: require('@/views/auth/PasswordReset').default }
                            // ]
                    // }
                ]
        },
    ]),
    ...applyRules(['MANAGER'], [
        {
            path: '', component: require('@/components/layouts/MainLayout').default, props: (route) => ({
                            date: route.query.date,
                            project: route.query.project
                    }), redirect: { name: 'projects'}, children:
                [
                    {
                        path: '/projects', alias: 'index', name: 'projects', component: require('@/views/ProjectsDashboard').default
                    },
                    { path: '/staffs', name: 'staffs', component: require('@/views/Staffs').default },
                    { path: '/timereport', name: 'timereport', component: require('@/views/TimeReport').default },
                    {
                        path: '/settings', alias: 'settings', name: 'settings', component: require('@/views/Settings').default, redirect: { name: 'my-account' }, children:
                            [
                                { path: 'accommodations', name: 'accommodations', component: require('@/components/settings/Accommodations').default },
                                { path: 'customers', name: 'customers-settings', component: require('@/components/settings/Customers').default },
                                { path: 'customers-contacts', name: 'customers-contacts', component: require('@/components/settings/CustomersContacts').default },                            
                                { path: 'categories', name: 'categories', component: require('@/components/settings/Categories').default },                            
                                // { path: 'project-categories', name: 'project-categories', component: require('@/components/settings/ProjectCategories').default },                            
                            ]
                    }
                ]
        }
    ]),
    ...applyRules(['ADMINISTRATOR'], [
        {
            path: '', component: require('@/components/layouts/MainLayout').default, props: (route) => ({
                            date: route.query.date,
                            project: route.query.project
                    }), redirect: { name: 'projects'},children:
                [
                    // { path: '/projects', alias: 'index', name: 'projects', component: require('@/views/ProjectsDashboard').default },
                    // { path: '/dashboard', name: 'dashboard', component: require('@/views/Dashboard').default },
                    // { path: '/assignments', name: 'assignments', component: require('@/views/Assignments').default },
                    // { path: '/schedule', name: 'schedule', component: require('@/views/Schedule').default },
                    { path: '/resources', name: 'resources', component: require('@/views/Resources').default },
                    { path: '/customers', name: 'customers', component: require('@/views/Customers').default },
                    { path: '/vehicules', name: 'vehicules', component: require('@/views/Vehicules').default },
                    {
                        path: '/settings', component: require('@/views/Settings').default, redirect: { name: 'general-settings'}, children:
                            [
                                // { path: 'my-account', name: 'my-account', component: require('@/components/settings/MyAccount').default },
                                // { path: 'my-profile', name: 'my-profile', component: require('@/components/settings/MyUserProfile').default },
                                { path: 'site-subscription', name: 'site-subscription', component: require('@/components/settings/SiteSubscription').default },
                                { path: 'user-profiles', name: 'user-profiles', component: require('@/components/settings/UserProfiles').default },
                                { path: 'resourceslist', name: 'resourceslist', component: require('@/components/settings/Resources').default },
                                { path: 'resourceTypes', name: 'resourceTypes', component: require('@/components/settings/ResourceTypes').default },
                                { path: 'absenceTypes', name: 'absenceTypes', component: require('@/components/settings/AbsenceTypes').default },
                                { path: 'companies', name: 'companies', component: require('@/components/settings/Companies').default },
                                { path: 'professions', name: 'professions', component: require('@/components/settings/Professions').default },
                                { path: 'skills', name: 'skills', component: require('@/components/settings/Skills').default },
                                { path: 'courses', name: 'courses', component: require('@/components/settings/Courses').default },
                                { path: 'custom-tag-labels', name: 'custom-tag-labels', component: require('@/components/settings/CustomTagLabels').default },
                                { path: 'custom-tags', name: 'custom-tags', component: require('@/components/settings/CustomTags').default },
                                { path: 'shift-templates', name: 'shift-templates', component: require('@/components/settings/ShiftTemplates').default },
                                { path: 'project-template', name: 'project-template', component: require('@/components/settings/ProjectTemplate').default },
                                { path: 'general-settings', name: 'general-settings', component: require('@/components/settings/GeneralSettings').default },
                            ]
                    }
                ]
        }
    ]),
    ...applyRules(['FOREMAN'], [
        {
            path: '', component: require('@/components/layouts/MainLayout').default, redirect: { name: 'schedule'}, props: (route) => ({
                            date: route.query.date,
                            project: route.query.project
                    }), children:
            [
                    { path: '/timesheetforeman', alias: 'timesheetforeman', name: 'timesheetforeman', component: require('@/views/TimeSheetForeman').default },
            ]
        }

    ]),
    ...applyRules(['STAFF'], [
        {
            path: '', component: require('@/components/layouts/MainLayout').default, redirect: { name: 'schedule'}, props: (route) => ({
                            date: route.query.date,
                            project: route.query.project
                    }), children:
                [
                    { path: '/schedule', alias: 'index', name: 'schedule', component: require('@/views/Schedule').default },
                    { path: '/timesheet', alias: 'timesheet', name: 'timesheet', component: require('@/views/Timesheet').default },
                    {
                        path: '/messages', name: 'messages', component: require('@/views/Messages').default, redirect: { name: 'inbox' }, children:
                            [
                                { path: '/inbox', name: 'inbox', component: require('@/components/notifications/Inbox').default },
                                { path: '/sent', name: 'sent', component: require('@/components/notifications/Sent').default },
                                { path: '/pendings', name: 'pendings', component: require('@/components/notifications/PendingsV2').default },
                                { path: '/pending', name: 'pending', component: require('@/components/notifications/PendingsV2').default },
                            ]
                    },
                    // {
                    //     path: '/messagesNew', name: 'messagesNew', component: require('@/views/Messages').default, redirect: { name: 'inboxNew' }, children:
                    //         [
                    //             { path: '/inboxNew', name: 'inboxNew', component: require('@/components/notifications/Inbox').default },
                    //             { path: '/sent', name: 'sent', component: require('@/components/notifications/Sent').default },
                    //             { path: '/pending', name: 'pending', component: require('@/components/notifications/Pending').default },
                    //         ]
                    // },
                    // {
                    //     path: '/assignments', name: 'assignments', component: require('@/views/Assignments').default
                    // },
                    { path: '/assignments', name: 'assignments', component: require('@/views/Assignments').default },
                    { path: '/help', name: 'help', component: require('@/views/Help').default },
                    { path: '/logout', name: 'logout', component: require('@/views/auth/Logout').default },
                    {
                        path: '/settings', component: require('@/views/Settings').default, redirect: { name: 'my-account'}, children:
                            [
                                { path: 'my-account', name: 'my-account', component: require('@/components/settings/MyAccount').default },
                                { path: 'my-profile', name: 'my-profile', component: require('@/components/settings/MyUserProfile').default },
                            ]
                    }
                ]
        }
    ]),
    ...applyRules(['auth'], [
        {
            path: '', component: require('@/components/layouts/AuthLayout').default, redirect: { name: 'changepassword' }, children:
                [
                    // { path: '/login', name: 'login', component: require('@/views/auth/Login').default },
                    { path: '/changepassword', alias: 'changepassword', name: 'changepassword', component: require('@/views/auth/PasswordChange').default },
                    // {
                    //     path: '/password', children:
                    //         [
                    //             { path: '', name: 'changepassword', component: require('@/views/auth/PasswordChange').default },
                    //         ]
                    // }
                ]
        },
    ]),

    { path: '*', redirect: { alias: 'index' } }
]

function applyRules(rules, routes) {
    for (let i in routes) {
        routes[i].meta = routes[i].meta || {}

        if (!routes[i].meta.rules) {
            routes[i].meta.rules = []
        }
        routes[i].meta.rules.unshift(...rules)

        if (routes[i].children) {
            routes[i].children = applyRules(rules, routes[i].children)
        }
    }
    // console.log('routes', routes)
    return routes
}
